export class Menu {
  DisplayInHomePage?: boolean;
  DisplayBadge?: boolean;
  SQLStatementIdForBadge?: number;
  FullPath?: string;
  Label: string;
  ParentMenu: number | string;
  Type: number;
  SortOrder: number;
  Icon: string;
  Url: string;
  Target?: any;
  Entitytype?: number;
  EntityId?: any;
  AdditionalInformation?: string;
  AdditionalInformationParsed?: any;
  ChildMenus?: Menu[];
  //FieldDescription?: string;
  //Areas?: number[];

  static getMenuUrl(menu: Menu): any {
    const data = menu.AdditionalInformationParsed.UrlDataParameters;
    const query = menu.AdditionalInformationParsed.UrlQueryParameters;

    let dataParsed = null;
    let queryParsed = null;
    if (data != null && data !== '') {
      dataParsed = JSON.parse(data);
    }

    if (query != null && query !== '') {
      queryParsed = JSON.parse(query);
    }

    if (dataParsed == null) {
      return [menu.Url];
    } else {
      return [menu.Url, dataParsed];
    }
  }
}
